import { unwrapReactive } from '@jack-henry/frontend-utils/lit';
import { WireIsoService, WireTemplate } from '@treasury/domain/wires';
// eslint-disable-next-line no-duplicate-imports
import type { WireIsoLabels } from '@treasury/domain/wires';
import { Wire } from '@treasury/domain/wires/wire.entity';
import { TmBaseComponent } from '@treasury/presentation';
import { informationIcon } from '@treasury/presentation/assets/icons';
import { html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import './wire-create-template';
import './wire-data-readonly';

export const tagName = 'wire-review-step';
@customElement(tagName)
export class WireReviewStep extends TmBaseComponent {
    @property({ type: Object })
    public wire?: Wire;

    @property({ type: Object })
    public wireTemplate: WireTemplate = new WireTemplate();

    @property({ type: Object })
    private wireIsoLabels: WireIsoLabels = WireIsoService.legacyLabels;

    @state()
    private saveTemplate = false;

    @state()
    private isValidTemplateName = false;

    @state()
    private creditorDetailOpen = false;

    public connectedCallback(): void {
        super.connectedCallback();
        this.wire = unwrapReactive(this.wire);
    }

    protected render() {
        if (!this.wire) {
            return nothing;
        }

        return html`<wire-data-readonly
                .wire=${this.wire}
                .wireIsoLabels=${this.wireIsoLabels}
                @view-creditor-detail=${() => {
                    this.creditorDetailOpen = true;
                }}
            ></wire-data-readonly>
            <div class="px-6 pt-4">
                <div class="flex">
                    <tm-icon
                        .icon=${informationIcon}
                        color="var(--secondary-text-color)"
                        width="18px"
                        height="18px"
                    ></tm-icon>
                    <div class="text-sm text-secondary pl-2">
                        <p>
                            Fees may be assessed for sending a wire payment. Please check your fee
                            schedule for current fees.
                        </p>
                        <p class="pt-3">
                            Additions or edits to purpose, additional information or End to End ID
                            will not be saved to the wire template.
                        </p>
                    </div>
                </div>
            </div>
            <wire-create-template
                class="mt-10"
                .wire=${this.wire}
                @update=${(e: CustomEvent) => {
                    this.saveTemplate = e.detail.saveTemplate;
                    if (this.saveTemplate) {
                        this.wireTemplate = e.detail.wireTemplate;
                        this.isValidTemplateName =
                            this.wireTemplate.name.length >= 3 && e.detail.isValidTemplateName;
                    } else {
                        this.isValidTemplateName = true;
                    }
                }}
            ></wire-create-template>
            <tm-footer
                .buttonConfig=${[
                    {
                        text: 'Initiate wire',
                        disabled: this.saveTemplate && !this.isValidTemplateName,
                        onClick: () => {
                            this.dispatchEvent(
                                new CustomEvent('confirm', {
                                    detail: {
                                        saveTemplate: this.saveTemplate,
                                        wireTemplate: this.wireTemplate,
                                    },
                                })
                            );
                        },
                    },
                ]}
            ></tm-footer
            >${this.renderCreditorDetail()}`;
    }

    private renderCreditorDetail() {
        return html`<tm-bottom-sheet
            .open=${this.creditorDetailOpen}
            @close=${() => {
                this.creditorDetailOpen = false;
            }}
        >
            <p slot="header-center">${this.wireIsoLabels.creditor} Detail</p>
            <tm-body .padding=${false}>
                <creditor-data-readonly
                    .creditor=${this.wire?.beneficiary}
                ></creditor-data-readonly></tm-body
        ></tm-bottom-sheet>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: WireReviewStep;
    }
}
